import { render, staticRenderFns } from "./DynamicListPage.vue?vue&type=template&id=7521456a&scoped=true"
import script from "./DynamicListPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicListPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DynamicListPage.vue?vue&type=style&index=0&id=7521456a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7521456a",
  null
  
)

export default component.exports